const POST_LOGIN_REDIRECT_KEY = 'postLoginRedirectPath';

/**
 * Remembers where to send the user once they're signed in. Call this right before redirecting an
 * unauthenticated user to /sign-in, so any protected deep link (e.g. a link from an email) can be
 * restored after login instead of being lost to the default landing page.
 */
export const setPostLoginRedirectPath = (path: string) => {
  sessionStorage.setItem(POST_LOGIN_REDIRECT_KEY, path);
};

/**
 * Reads and clears the remembered post-login path, if any. Call this once, right after a
 * successful sign-in, before falling back to the default landing page.
 */
export const consumePostLoginRedirectPath = (): string | null => {
  const path = sessionStorage.getItem(POST_LOGIN_REDIRECT_KEY);
  sessionStorage.removeItem(POST_LOGIN_REDIRECT_KEY);
  return path;
};
